import { apiClient, assertOk } from "@/api/generated/client"

import type { FarmBalance } from "../types/farmBalanceTypes"

export const getFarmBalances = async (
  year: number,
  month?: number,
  quarter?: number,
): Promise<FarmBalance[]> => {
  const { response, error, data } = await apiClient.GET("/api/Logistics/balance", {
    params: { query: { Year: year, Month: month, Quarter: quarter } },
  })
  const res: FarmBalance[] = assertOk(response, error, data)
  return res
}
